import artsy from "./assets/projectsImg/artsy.jpg";
import course from "./assets/projectsImg/course.jpg";
import crappo from "./assets/projectsImg/crappo.jpg";
import ency from "./assets/projectsImg/ency.jpg";
import getset from "./assets/projectsImg/getset.jpg";
import shortly from "./assets/projectsImg/shortly.jpg";
import space from "./assets/projectsImg/space.jpg";
import tipsy from "./assets/projectsImg/tipsy.jpg";
import tweet from "./assets/projectsImg/tweet.jpg";
import song from "./assets/projectsImg/song.jpg";
import candy from "./assets/projectsImg/candy.jpg";
import unify from "./assets/projectsImg/unify.jpg";
import owasp from "./assets/projectsImg/owasp.jpg";
import linkfree from "./assets/projectsImg/linkfree.jpg";
import Exp1 from "./assets/projectsImg/Exp1.jpg";
import Exp2 from "./assets/projectsImg/Exp2.jpg";
import Exp3 from "./assets/projectsImg/Exp3.jpg";
import Exp4 from "./assets/projectsImg/Exp4.jpg";
import Exp5 from "./assets/projectsImg/Exp5.jpg";

const images = {
  artsy,
  course,
  candy,
  owasp,
  linkfree,
  unify,
  crappo,
  ency,
  getset,
  shortly,
  space,
  tipsy,
  tweet,
  song,
  Exp1,
  Exp2,
  Exp3,
  Exp4,
  Exp5,
};

function getImageByKey(key) {
  return images[key];
}

export default getImageByKey;
